import { Routes } from '@angular/router';
import * as fromCore from './core';
import * as fromCreditReport from './credit-report';
export const routes: Routes = [
  {
    path: '',
    redirectTo: '/credit-report-summary-search',
    // component: fromCore.HomeComponent,
    pathMatch: 'full'
  }, //	TODO: map to app component to redirect based upon user's identity
  {
    path: 'autologin',
    redirectTo: ''
  },
  { path: 'unauthorized', component: fromCore.UnauthorizedComponent },
  {
    path: 'credit-report-reasons',
    canActivate: [fromCreditReport.CreditReportGuard],
    component: fromCreditReport.CreditReportReasonsComponent
  },
  {
    path: 'credit-report-summary',
    canActivate: [fromCreditReport.CreditReportGuard],
    component: fromCreditReport.CreditReportSummaryComponent
  },
  {
    path: 'credit-report-summary-search',
    canActivate: [fromCreditReport.CreditReportGuard],
    component: fromCreditReport.CreditReportSummarySearchComponent
  },
  { path: '401', component: fromCore.UnauthorizedComponent },
  { path: '500', component: fromCore.UnexpectedErrorComponent },
  { path: '404', component: fromCore.NotFoundComponent },
  { path: '**', redirectTo: '/404' }
];
